import type {
	IntegrationAppListingField,
	IntegrationAppListingProposalStatus,
} from "@repo/shared-primitives"

/** Human label of each listing field an owner can propose a change to. */
export const LISTING_FIELD_LABELS: Record<IntegrationAppListingField, string> =
	{
		name: "Name",
		shortDescription: "Short description",
		longDescription: "Long description",
		logoUrl: "Logo",
		websiteUrl: "Website URL",
		screenshots: "Screenshots",
		categories: "Categories",
		developerName: "Developer name",
		supportUrl: "Support URL",
		privacyPolicyUrl: "Privacy policy URL",
		termsUrl: "Terms of service URL",
		games: "Games",
		languages: "Languages",
	}

/** Label of each proposal status. */
export const LISTING_PROPOSAL_STATUS_LABELS: Record<
	IntegrationAppListingProposalStatus,
	string
> = {
	pending: "Pending",
	accepted: "Accepted",
	rejected: "Rejected",
	withdrawn: "Withdrawn",
	partially_accepted: "Partially accepted",
}
